import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var CancelOrderIA = function CancelOrderIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4agNLN",
    defaultMessage: [{
      "type": 0,
      "value": "As encomendas podem ser canceladas em circunstâncias específicas antes de atingirem determinadas fases de processamento. Para obter mais informações sobre o motivo pelo qual uma encomenda específica foi cancelada, aceda à "
    }, {
      "children": [{
        "type": 0,
        "value": "página de informações da encomenda"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " e consulte o respetivo calendário. Aqui está uma visão geral de quando as encomendas podem ser canceladas."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8z47MZ",
    defaultMessage: [{
      "type": 0,
      "value": "Em primeiro lugar, pode cancelar encomendas não processadas se não as conseguir processar por motivos específicos, como problemas de inventário ou conflitos de exclusividade."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks, brandOrderToken);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4ZAq1R",
    defaultMessage: [{
      "type": 0,
      "value": "Os revendedores têm 24 horas para cancelar novas encomendas, desde que ainda não tenham sido aceites. Após este período ou após aceitar uma encomenda, os pedidos de cancelamento serão enviados para si e pode aceitá-los ou rejeitá-los."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "7c/yYT",
    defaultMessage: [{
      "type": 0,
      "value": "Por último, as encomendas podem ser automaticamente canceladas pela Faire se houver longos atrasos no cumprimento. Isto pode acontecer se não introduzir uma data de envio esperada para novas encomendas no prazo de 30 dias ou se não fornecer informações de acompanhamento de uma encomenda aceite no prazo de 30 dias após a data de envio especificada."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrders(),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};